import React, {Fragment, useEffect, useState, useRef} from 'react';
import {DurationTagPicker, Flex, Button, Tabs, Icon, Icons, Duration, Card} from 'components';
import {over, fullday, useNamedSelector, useInterval, openPopup, useUpdate} from 'helpers';
import {store} from 'store';
import {update, updateStatus} from 'store/activities';
import css from './timer.module.scss';

export function Timer({ activity: { id }, contextDate, status, duration }) {
  const ref = useRef();
  const activity = useNamedSelector('activities.activity', { id });
  const update = useUpdate();
  const timer = useNamedSelector('calendar.timer', { id, date: contextDate });
  const runnable = contextDate && (!status || status == 'Not Started');

  useInterval(() => update({}), timer.isRunning ? 1000 : null);
  duration = duration || activity.duration;

  return Boolean(timer.getTime() || duration || activity.allDay) && (
    <Fragment>
      <Icon
        onClick={runnable && openPopup(TimerPopup, { id, contextDate })}
        Sub={timer.getResult() ? Icons.Circle : ( runnable && Icons.Play )}
        isBlinking={timer.isRunning}
        alert={timer.isRunning}
        name={timer.getResult() ? timer.unit : 'timer-default'}
        className={`${Card.css.highlight} pull-right`}
        ref={ref}
      />
      <Duration
        onClick={runnable && openPopup(TimerPopup, { id, contextDate })}
        value={timer.getTime() || duration*60 || activity.allDay && fullday*60}
        hideSeconds={!timer.getResult()}
      />
    </Fragment>
  );
}

export function TimerPopup({ id, contextDate, popup }) {
  const activity = useNamedSelector('activities.activity', { id });
  const [ , updateState ] = useState();
  const timer = useNamedSelector('calendar.timer', { id, date: contextDate });

  useInterval(() => updateState({}), timer.isRunning ? 1000 : null);

  useEffect(popup.bounce, [ timer.unit, activity.duration ]);

  const stop = () => updateStatus({ result: null, id: activity.id, contextDate });

  return (
    <div className={css.popup}>
      <Tabs className="small">
        <Tabs.Tab onClick={() => updateStatus({ unit: 'stopwatch', id: activity.id, contextDate })} pressed={timer.unit == 'stopwatch'}>Stopwatch</Tabs.Tab>
        <Tabs.Tab onClick={() => updateStatus({ unit: 'timer', id: activity.id, contextDate })} pressed={timer.unit == 'timer'}>Timer</Tabs.Tab>
        <Icon className="pull-right secondary" name="close" onClick={popup.close} />
      </Tabs>
      <div className={css('time', 'centered')}>
        { (timer.unit == 'stopwatch' || activity.duration > 0) &&
          <b><Duration value={timer.getTime()} forceSeconds /></b>
        }
        <Fragment>
          { (timer.unit == 'stopwatch' || activity.duration > 0) &&
            <small>{ timer.unit == 'stopwatch'  ? 'out of' : 'left' }</small>
          }
          <DurationTagPicker
            value={activity.duration}
            setValue={over(duration => update({ id: activity.id, duration }), stop)}
            placeholder="+ duration"
          />
        </Fragment>
      </div>
      <TimerControls activity={activity} timer={timer} contextDate={contextDate} />
    </div>
  );
}

export function TimerControls({ activity, timer, contextDate }) {
  const toggle = () => store.dispatch({
    type: 'ACTIVITIES_TOGGLE_TIMER',
    id: activity.id,
    contextDate,
  });

  const reset = () => updateStatus({
    result: null,
    id: activity.id,
    contextDate
  });

  if (!activity.duration && timer.unit == 'timer') {
    return (
      <p className="text-center secondary">
        Add duration first.
      </p>
    );
  }

  return (
    <Flex className="center">
      { (timer.unit != 'timer' || timer.getTime() > 0) &&
        <Button className={['tiny', 'primary']} icon={timer.isRunning ? 'pause' : 'play'} onClick={toggle}>
          { timer.isRunning ? 'pause' : timer.getTime() ? 'resume' : 'start' }
        </Button>
      }
      { !timer.isRunning && (timer.getTime() > 0 || timer.unit == 'timer') &&
        <Button className={['tiny']} icon="reset" onClick={reset}>Reset</Button>
      }
    </Flex>
  );
}
